import get from 'lodash/get';

export const generateName = (data) => {
  const firstName = get(data, 'firstName', '');
  const lastName = get(data, 'lastName', '');

  return `${firstName} ${lastName}`;
};
